import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import Utils from 'utils/Utils';

import useStyles from './styles';

const Logo = ({ className }) => {
    const { classes, cx } = useStyles();

    return (
        <picture>
            <source srcSet={Utils.getImage('logo_small')} media="(max-width: 960px)" />
            <source srcSet={Utils.getImage('logo')} media="(min-width: 960px)" />
            <Link to={'/'}>
                <img className={cx(classes.logo, className)} src={Utils.getImage('logo')} alt="Logo" />
            </Link>
        </picture>
    );
};

Logo.propTypes = {
    className: PropTypes.string
};

export default Logo;
